var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDdaClosingReportNoGaps = function SvgDdaClosingReportNoGaps(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#DFF5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.047 8.20154C17.3038 8.41103 17.3421 8.78899 17.1326 9.04574L11.9653 15.3787C11.9592 15.3863 11.9529 15.3936 11.9464 15.4008C11.6286 15.7539 11.2306 15.9814 10.7546 15.9612C10.3176 15.9427 9.93717 15.7172 9.62558 15.468C9.61869 15.4624 9.61192 15.4568 9.60527 15.451L6.93926 13.1179C6.68989 12.8997 6.66464 12.5207 6.88286 12.2713C7.10108 12.0219 7.48014 11.9967 7.72951 12.2149L10.385 14.5387C10.6188 14.7239 10.7493 14.7599 10.8055 14.7623C10.8058 14.7623 10.8061 14.7623 10.8065 14.7624C10.826 14.7633 10.8996 14.7666 11.0456 14.6078L16.2028 8.28711C16.4123 8.03036 16.7903 7.99205 17.047 8.20154Z",
    fill: "#028838"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDdaClosingReportNoGaps);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dda-closing-report-no-gaps.08ea6bee236ae9d85ca38702e180eb19.svg";